import { SvgIcon } from '@mui/material';

const Icon = (props: any) => (
  <SvgIcon {...props} viewBox="0 0.375 15 11.25">
    <path
      paintOrder="stroke fill markers"
      fillRule="evenodd"
      d="M14.716 4.382l-1.842-3.137A.745.745 0 0 0 11.867.98l-1.598.905 1.382 2.354a.18.18 0 0 1-.067.248l-.32.18a.185.185 0 0 1-.251-.067L9.63 2.247l-1.277.725.646 1.097a.18.18 0 0 1-.068.248l-.319.18a.185.185 0 0 1-.252-.067l-.646-1.095-1.278.725L7.82 6.414a.18.18 0 0 1-.067.248l-.32.18a.185.185 0 0 1-.251-.067L5.799 4.421l-1.277.725.646 1.097a.18.18 0 0 1-.068.247l-.319.181a.185.185 0 0 1-.252-.067l-.646-1.1-1.278.725 1.382 2.354a.18.18 0 0 1-.067.248l-.32.18a.185.185 0 0 1-.252-.067L1.966 6.597.37 7.502a.72.72 0 0 0-.27.99l1.842 3.14a.745.745 0 0 0 1.007.266l11.5-6.526a.718.718 0 0 0 .268-.99z"
    />
  </SvgIcon>
);

export default Icon;
